/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { importTeamSearchResultSchema } from './importTeamSearchResultSchema';

export const importTeamsRequestSchema = z.object({
  instanceId: z.string().min(1),
  sourceType: z.enum(['JIRA_TEAM', 'TEMPO_TEAM', 'ADO_TEAM']),
  get teams() {
    return z.array(importTeamSearchResultSchema);
  },
});
